/**
 * An array of income type options, each represented as an object with `value` and `label` properties.
 * 
 * @type {Array<{ value: string, label: string }>}
 * @property {string} value - The value of the income type option.
 * @property {string} label - The display label for the income type option.
 * 
 * Example:
 * [
 *   { value: "State Pension", label: "State Pension" },
 *   { value: "DB Pension", label: "DB Pension" },
 *   { value: "Rental Income", label: "Rental Income" },
 *   { value: "Other Income", label: "Other Income" }
 * ]
 */
const IncomeTypeOptions = [
  "State Pension",
  "DB Pension",
  "Rental Income",
  "Other Income",
].map((type) => ({ value: type, label: type }));

export default IncomeTypeOptions;
